import script from "./ReturPrekursor.vue?vue&type=script&setup=true&lang=js"
export * from "./ReturPrekursor.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__